import React from "react";
import "./BlockPlaceholder.css";

const BlockPlaceholder = () => {
  return <div className="BlockPlaceholder">Drop Your Block</div>;
};

export default BlockPlaceholder;
